import React, { useState, useEffect } from "react";
import { Button, Col, Container, Row, Spinner } from "react-bootstrap";
import "./CampaignCsv.scss";
import { GET_CSV_FIELDS, GET_GLOBAL_OUTBOUNDS_FIELDS } from '../../../gql/campaign/leads/queries';
import { UPDATE_OUTBOND_FIELDS } from '../../../gql/campaign/leads/mutation';
import { useMutation, useLazyQuery } from '@apollo/client';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import useUnsavedChangeWarning from '../../../hooks/useUnsavedChangeWarning';
import { useParams, useHistory } from 'react-router-dom';

const CampaignCsv = () => {
  const { id } = useParams()
  const history = useHistory()
  const [csvFields, setCsvFiles] = useState([]);
  const [outboundFields, setOutboundFields] = useState([])
  const [mappedFields, setMappedFields] = useState([])
  const [errorMessage, setErrorMessage] = useState('')
  const [Prompt, setIsDirty, setPristine] = useUnsavedChangeWarning()
  const [csvMapped, setCsvMapped] = useState(false)
  const [fetchedCsvField, setFetchedCsvField] = useState(false)
  const emailData = ["email", "email 1", "email 2", "mail", "email address", "e-address"];
  const [leadPageRedirect, setLeadPageRedirect] = useState(false);
  const [campaignTypeAvailable, setCampaignTypeAvailable] = useState(false)

  const [getCsvFields] = useLazyQuery(GET_CSV_FIELDS, {
    onCompleted(data) {
      setCsvFiles(data?.getCSVFieldList?.csvFields)
      setFetchedCsvField(true)
      setCampaignTypeAvailable(data?.getCSVFieldList?.campaignTypeAvailable)
    },
    onError(error) {
      if (error) {
        if (error.networkError && typeof window !== 'undefined' && !window.navigator.onLine) {
          setErrorMessage("Check Your Network, Your Browser Is Offline")
        }
        if (error.message) {
          setErrorMessage(error.message)
        }
        if (!error.message) {
          setErrorMessage("Something Went Wrong !")
        }
      }
    },
    fetchPolicy: 'network-only'
  })

  const [getGlobalOutboundFields] = useLazyQuery(GET_GLOBAL_OUTBOUNDS_FIELDS, {
    onCompleted(data) {
      setOutboundFields(data?.getGlobalOutboundFieldList)
    },
    onError(error) {
      if (error) {
        if (error.networkError && typeof window !== 'undefined' && !window.navigator.onLine) {
          setErrorMessage("Check Your Network, Your Browser Is Offline")
        }
        if (error.message) {
          setErrorMessage(error.message)
        }
        if (!error.message) {
          setErrorMessage("Something Went Wrong !")
        }
      }
    },
    fetchPolicy: 'network-only'
  })

  const [updateOutboundFields, { loading }] = useMutation(UPDATE_OUTBOND_FIELDS, {
    onCompleted(data) {
      setPristine()
      if (data?.updateOutboundFields) {
        setCsvMapped(true)
      }
    },
    onError(error) {
      if (error) {
        if (error.networkError && typeof window !== 'undefined' && !window.navigator.onLine) {
          setErrorMessage("Check Your Network, Your Browser Is Offline")
        }
        if (error.message) {
          setErrorMessage(error.message)
        }
        if (!error.message) {
          setErrorMessage("Something Went Wrong !")
        }
      }
    },
  })

  useEffect(() => {
    if (id) {
      getCsvFields({
        variables: {
          campaignId: id
        }
      })

      getGlobalOutboundFields()

    }

    //eslint-disable-next-line
  }, [])

  useEffect(() => {
    if (id) {
      let newArray = []
      csvFields && csvFields.length > 0 && csvFields.map((item, idx) => {
        // if(item === 'email'){
        if(emailData.includes(item.toLowerCase().split(" ")[0])){
          let newField = { fieldName: item, fieldValue: "email" }
          newArray = [...newArray, newField]
        }
        else{
          let newField = { fieldName: item, fieldValue: "customVariable" }
          newArray = [...newArray, newField]
        }
      return setMappedFields(newArray)   

      })
    }

    //eslint-disable-next-line
  }, [fetchedCsvField])

  useEffect(() => {
    if (history?.location?.search === "?leadTrue") setLeadPageRedirect(true);
  }, [leadPageRedirect, history]);

  const renderOptions = (data) => {
    try {
      if (outboundFields && outboundFields.length > 0) {
        return outboundFields.map((item) => {
          if(emailData.includes(data.toLowerCase().split(" ")[0])){
            return (
              <option  className="outbond-fields" selected={ item.fieldValue === "email" ? true : false } value={item.fieldValue} key={item._id}  > {item.fieldName} </option>
            )
          }
          else{
            return <option className="outbond-fields" value={item.fieldValue} key={item._id} >{item.fieldName}</option>
          }
        })
      }
    }
    catch (error) {
      console.error(error)
    }
  }

  if (errorMessage) {
    toast.error(errorMessage, {
      position: "bottom-right",
      closeOnClick: true,
    })
    setErrorMessage('')
  } 

  if (csvMapped) {
    if((leadPageRedirect && id) || (campaignTypeAvailable && id)){
      history.push(`/campaigns/leads/${id}`)
    }
    else if (id) {
      history.push(`/campaignSuccess/${id}`) 
    } else {
      history.push('/campaignSuccess')
    }
  }

  const handleSave = () => {
    if (mappedFields.length === 0) {
      return toast.error('No Fields Mapped.', {
        position: "bottom-right",
        closeOnClick: true,
      })
    }
    if (!id) {
      return toast.error('Choose Campaign First.', {
        position: "bottom-right",
        closeOnClick: true,
      })
    }
    updateOutboundFields({
      variables: {
        outboundFieldsInput: {
          campaignId: id,
          outboundFields: mappedFields
        }
      }
    })
  }


  return (
    <>
      <Container
        fluid
        className="campaign-csv-outbound-container"
        style={{ overflowY: "hidden", paddingBottom: '20px' }}
      >
        <div className='create-title'>
          <h4>Leads Mapping</h4>
        </div>
        <Row className="campaign-fields-container">
          <Col className="csv-fields-container">
            <div className="text-center mt-5 mb-4">
              <span className="csv-fields-heading">CSV Fields</span>
            </div>
            {
              csvFields && csvFields.length > 0 && csvFields.map((item, idx) => (
                <div className="csv-fields-label" key={idx}>
                  <label
                    className="csv-fields form-label "
                    htmlFor="exampleFormControlInput1"
                  >
                    {item}
                  </label>
                </div>
              ))
            }
          </Col>

          <Col className="outbound-fields-container">
            <div className="text-center mt-5 mb-4">
              <span className="outbound-fields-heading">Outbound Fields</span>
            </div>
            <form>
              {
                csvFields && csvFields.length > 0 && csvFields.map((item, idx) => (
                  <div className="outbound-fields " key={idx}>
                    <select
                      className=" outbound-fields form-select padding-1600"
                      style={{ borderRadius: "8px" }}
                      onChange={(e) => {
                        setIsDirty()
                        if (mappedFields.length === 0) {
                          setMappedFields([...mappedFields, { fieldName: item, fieldValue: e.target.value }])
                        }
                        else {
                          let newField = { fieldName: item, fieldValue: e.target.value }
                          // const newArray = mappedFields.filter(obj => obj.fieldName !== item).concat(newField)
                          const newArray = [...mappedFields.filter((obj) => obj.fieldName !== item), { ...newField }]
                          setMappedFields(newArray)
                        }
                      }}
                    >
                      {renderOptions(item)}

                    </select>
                  </div>
                ))
              }
            </form>
          </Col>
        </Row>

        <Row className="text-center outbound-fields-save-btn-container">
          <Col className="my-auto">
            {
              loading ?
                <Button className="outbound-fields-save-btn">Save &nbsp;
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                </Button>
                :
                <Button className="outbound-fields-save-btn next_btn_lead" onClick={handleSave}  >Save</Button>
            }
          </Col>
        </Row>
      </Container>
      {Prompt}
    </>
  );
};

export default CampaignCsv;

